import React from 'react';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    variant?: "default" | "outline" | "secondary" | "destructive" | "warning";
}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(({
    className = "",
    variant = "default",
    children,
    ...props
}, ref) => {
    const variants = {
        default: "bg-wood-dark text-parchment border border-wood-darker",
        outline: "bg-transparent border border-wood-medium text-wood-darker dark:text-wood-light",
        secondary: "bg-[#fff8e1] text-[#f57c00] border border-[#ffe0b2]", // Matches existing tag style
        destructive: "bg-red-100 text-red-800 border border-red-200",
        warning: "bg-yellow-100 text-yellow-800 border border-yellow-200",
    };

    return (
        <span
            ref={ref}
            className={`
        inline-flex items-center px-1.5 py-0.5 
        text-xs font-bold 
        rounded md:rounded bg-clip-padding
        ${variants[variant]}
        ${className}
      `}
            {...props}
        >
            {children}
        </span>
    );
});

Badge.displayName = "Badge";
